<template>
  <div class="" style="position: relative;">
    <v-toolbar>
      <v-toolbar-title>マップ生成ツール Ver1.01</v-toolbar-title>
    </v-toolbar>

    <v-card class="pa-4" max-width="1200px" style="margin: 10px auto;">
      <v-container class="ma-0">
        <v-row class="justify-center align-center">
          <v-col cols="4">
            <v-text-field
              label="検索"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              clearable
              outlined
              rounded
              placeholder="親マップのみ検索できます。"
              hide-details="true"
              @change="saveSearch"
            ></v-text-field>
          </v-col>
          <v-col cols="6"> </v-col>

          <v-col cols="2" style="text-align:right">
            <v-btn color="primary" class="pa-4" @click="detail('new', false)"
              >+ 新規登録</v-btn
            >
          </v-col>
        </v-row>
      </v-container>

      <v-overlay :absolute="absolute" :value="overlay" :opacity="opacity">
        <v-progress-circular indeterminate color="green"></v-progress-circular>
      </v-overlay>
      <v-data-table
        :headers="headers"
        :items="main_items"
        :items-per-page="25"
        :footer-props="{ itemsPerPageOptions: [25, 50, 100, -1] }"
        sort-desc
        fixed
        :search="search"
      >
        <template v-slot:item="{ item, index }">
          <tr v-bind:class="tableColor(index)">
            <td class="text-center">
              <v-btn
                outlined
                class="transparent"
                @click="detail(item.id, false)"
              >
                <v-icon small color="primary">fas fa-edit</v-icon>
              </v-btn>
            </td>

            <td class="text-center">
              {{ item.id }}
            </td>
            <!-- <td class="center">{{ item.id }}</td> -->

            <td>{{ item.name }}</td>

            <td></td>

            <td width="60">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="blue" dark v-bind="attrs" v-on="on">
                    <v-icon small color="primary" class=""
                      >fas fa-caret-down</v-icon
                    >
                  </v-btn>
                </template>
                <v-list class="menu">
                  <v-list-item dense>
                    <v-list-item-title>
                      <v-btn color="white" @click="detail(item.id, true)"
                        >コピーして作成</v-btn
                      ></v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item dense>
                    <v-list-item-title>
                      <v-btn
                        width="100%"
                         color="white"
                        @click="subdetail(-1, item.id, true)"
                        >分割編集</v-btn
                      ></v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
          <tr
            v-for="child in sub_items[item.id]"
            v-bind:key="item.id+'_'+child.id"
            v-bind:class="tableColor(index)"
          >
            <td class="text-center"></td>
            <td class="text-center">  </td>
            <td colspan="2">
              └
              <v-btn
                outlined
                class="transparent pl-1"
                @click="subdetail(child.id, child.parent_id, false)"
              >
                <v-icon small color="primary">fas fa-edit</v-icon></v-btn
              >{{ child.id }}. {{ child.name }}
            </td>
            <td>
              <v-btn
                outlined
                style="color:#888"
                class="transparent"
                @click="subdelete(child.parent_id , child.id, child.name)"
                ><v-icon small color="">fas fa-trash</v-icon>
                </v-btn
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "MapGenerateList",
  components: {},
  data() {
    return {
      absolute: true,
      opacity: 0.1,
      overlay: true,

      headers: [
        {
          text: "編集",
          align: "center",
          value: "id",
          sortable: false,
          width: "70px",
        },
        {
          text: "ID",
          align: "center",
          value: "id",
          sortable: false,
          width: "80px",
        },
        {
          text: "保存名",
          align: "left",
          value: "name",
          sortable: false,
        },
        {
          text: "",
          align: "left",
          value: "name",
          sortable: false,
          width: "100px",
        },
      ],
      main_items: [],
      sub_items: [],

      search: "",
    };
  },
  mounted() {
    var self = this;

    this.search = localStorage.getItem("map_search") || "";
    if(this.search == "null"){
      this.search = "";
    }

    axios
      .get(process.env.VUE_APP_MAP_LIST, {
        data: "",
      })
      .then(function(response) {
        self.main_items = response.data["main"];
        self.sub_items = response.data["sub"];

        // console.log(self.main_items);
      })
      .finally(function() {
        self.overlay = false;
      });
  },

  computed: {},

  watch: {},

  methods: {
    detail(page_id, copy_mode) {
      this.$router.push({
        name: "mapDetail",
        params: { id: page_id, copy: copy_mode },
      });
    },
    subdetail(page_id, parent_id, copy_mode) {
      this.$router.push({
        name: "mapSubDetail",
        params: { id: page_id, parent_id: parent_id, copy: copy_mode },
      });
    },
    subdelete(parent_id,child_id, name) {
      console.log(child_id);

      if (
        window.confirm("サブマップ「" + name + "」のデータを削除しますか？\n")
      ) {
        axios
          .post(process.env.VUE_APP_MAP_SUB_DELETE, {
            data: {parent_id: parent_id ,  id: child_id },
          })
          .then(function() {
            alert("削除しました。");
          })
          .finally(function() {
            location.reload();
          });
      }
    },

    saveSearch(){
       localStorage.setItem("map_search", this.search);
    },

    tableColor(index) {
      index = index + 1;
      if (index % 2 == 0) {
        return "tr_color";
      }
      return "tr_normal";
    },
  },
};
</script>
<style scoped>
.tr_color {
  background: #f5f8fe;
}
.menu .v-list-item {
  border-bottom: 1px solid #ddd;
}
.theme--light.v-list {
  padding: 0;
}
</style>
